// import of a statemanager store. Adjust to meet component requirements.
import { useMainStore } from 'stores/main.store'
import { computed,onMounted,onUnmounted,ref, watch } from 'vue'
import OverlayPrompt from './OverlayContent/OverlayPrompt/OverlayPrompt.vue'
import OverlayMenu from './OverlayContent/OverlayMenu/OverlayMenu.vue'
import OverlayLeadGate from './OverlayContent/OverlayLeadGate/OverlayLeadGate.vue'

import OverlayTypes from './OverlayTypes'

export default {
    name: "Overlay",
    components: {
        OverlayPrompt, 
        OverlayMenu,
        OverlayLeadGate
    },
    props: {
        showOverlay: {
            type: Boolean,
            required: false,
            default: null
        },
        titleText: {
            type: String,
            required: false,    
            default: null
        },
        content: {
            type: Object,
            required: false,
            default: null
        },
        overlayType: {
            type: String,
            required: false,
            default: null
        }
    },
    setup(props){

        const store = useMainStore()

        store.changeOverlaySettings({
            "showOverlay": false,
            "overlayType": props.overlayType,
            "titleText": props.titleText,
            "content": props.content
        })

        const overlayDisplayStatus = computed(()=>!props.showOverlay ? store.overlayContent.showOverlay : props.showOverlay)
        const currentOverlayContent = computed(()=>store.overlayContent.overlayType)
        const styles = computed(()=>store.overlayData.styles)
        
        let dialogElement = ref('')

        let closeTheModal = function() {
            dialogElement.value.close()
            store.clearOverlay()
        }

        function trapFocus(event) {

            // Function to check if an element is visible and focusable
            function isElementFocusable(el) {
                // Check if the element is the <summary> of a <details> element
                const isSummary = el.tagName.toLowerCase() === 'summary';
              
                // Check if the element is focusable by size, disabled state, and visibility
                const isVisible =
                  el.offsetWidth > 0 &&
                  el.offsetHeight > 0 &&
                  window.getComputedStyle(el).visibility !== 'hidden';
              
                const isNotDisabled = !el.disabled;
              
                // Check if the element is inside a <details> element that is closed
                const detailsParent = el.closest('details');
                const isDetailsOpen = detailsParent ? detailsParent.open : true;
              
                // The <summary> element should always be focusable even if <details> is closed
                return isSummary || (isVisible && isNotDisabled && isDetailsOpen);
            }

            // Function to get focusable elements by traversing the DOM
            function getFocusableElements(container) {
                const focusableElements = [];

                function traverse(element) {
                    if (isElementFocusable(element)) {
                        focusableElements.push(element);
                    }

                    // Traverse the children recursively
                    for (let child of element.children) {
                        traverse(child);
                    }
                }

                // Start traversal from the container
                traverse(container);
                return focusableElements;
            }

            const focusableElements = getFocusableElements(dialogElement.value)
            const firstElement = focusableElements[0]
            const lastElement = focusableElements[focusableElements.length - 1]
        
            if (event.key === 'Tab') {
              if (event.shiftKey) {
                // If Shift + Tab is pressed and focus is on the first element
                if (document.activeElement === firstElement) {
                  event.preventDefault()
                  lastElement.focus() // Focus on the last element
                }
              } else {
                // If Tab is pressed and focus is on the last element
                if (document.activeElement === lastElement) {
                  event.preventDefault()
                  firstElement.focus() // Focus on the first element
                }
              }
            }
        }

        onMounted(()=>{
            document.addEventListener('keydown', trapFocus); // Start trapping focus
        })


        watch(currentOverlayContent,(contentType,old)=>{
            if(contentType === OverlayTypes.mainMenu){
                //const megaMenus = document.querySelector('')
            }
        })

        watch(overlayDisplayStatus,(changed, old)=>{
            if(changed){
                dialogElement.value.showModal()

                // enable modal closing when the user mouseclicks on the backdrop
                dialogElement.value.addEventListener('click', (event) => {
                    // The dialog element acts as the backdrop when clicked outside of its content
                    const rect = dialogElement.value.getBoundingClientRect();
                    const isInDialog = (
                        event.clientX >= rect.left &&
                        event.clientX <= rect.right &&
                        event.clientY >= rect.top &&
                        event.clientY <= rect.bottom
                    );
            
                    // If the click is outside the dialog content, close the dialog
                    if (!isInDialog) {
                        dialogElement.value.close()
                        store.clearOverlay()
                    }
                })
            }
        })

        return {
            closeTheModal,
            currentOverlayContent,
            dialogElement,
            styles,
            OverlayTypes,
            overlayContent: computed(()=>store.overlayContent)
        }
    }
}